
require.register("mathml/app/MathML/operationMap.js", function(exports, require, module) {
  require = __makeRelativeRequire(require, {}, "mathml");
  (function() {
    'use strict';
function line(sign) {
    return `<mrow><mo>${sign}</mo></mrow>`;
}
module.exports = {
    divide: line('÷'),
    times: line('·'),
    power: line('^'),
    sqrt: line('√'),
    partialdiff: line('∂'),
    apply: line('@'),
    subscript: line('?_'),
    superscript: line('?^')
};
  })();
});